<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
          <div class="form-group row">
          <!-- <label class="col-form-label col-2"><span translate="VERSKIPRAZNIK.NAZIV.SINGULAR"></span></label> -->
          <div class="col-md-10">
            <yt-input
              [Type]="'text'"
              [Label]="'VERSKIPRAZNIK.NAZIV.SINGULAR'"
              name="txtNaziv"              
              formControlName="Naziv"
              #autofocus    
              [ngClass]="{'is-invalid': submitted && fc.Naziv.invalid}"
            ></yt-input>
            <div class="form-error" *ngIf="submitted && fc.Naziv.invalid">
              <span *ngFor="let validation of errorMessages.Naziv">
                <span class="error-message" *ngIf="fc.Naziv.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
              <!-- <span *ngIf="fc.Naziv.errors.required">Naziv je obavezan podatak</span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
          <div class="form-group row">
          <!-- <label class="col-form-label col-2">
            <span translate="VERSKIPRAZNIK.DAN.SINGULAR"></span>
          </label> -->
          <div class="col-md-10">
            <yt-input
              [Type]="'text'"
              [Label]="'VERSKIPRAZNIK.DAN.SINGULAR'"
              name="txtDan"              
              formControlName="Dan"
              maxlength="2"
            ></yt-input>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
          <div class="form-group row">
          <!-- <label class="col-form-label col-2">
            <span translate="VERSKIPRAZNIK.MESEC.SINGULAR"></span> 
          </label> -->
          <div class="col-md-10">
            <yt-input
              [Type]="'text'"
              [Label]="'VERSKIPRAZNIK.MESEC.SINGULAR'"
              name="txtMesec"              
              formControlName="Mesec"
              maxlength="2"
            ></yt-input>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <!-- <label class="col-form-label col-2">
            <span translate="VERSKIPRAZNIK.GODINA.SINGULAR"></span> 
          </label> -->
          <div class="col-md-10">
            <yt-input
              [Type]="'text'"
              [Label]="'VERSKIPRAZNIK.GODINA.SINGULAR'"
              name="txtGodina"              
              formControlName="Godina"
              maxlength="4"
            ></yt-input>
          </div>
        </div>
      </div>
      <div class="form-group row">
          <div class="col-md-12">
          <!-- <label>
            <span translate="NOTE.RELIGIOSHOLIDAY"></span>
          </label> -->
          </div>
      </div>
    </div>

  </div>
</form>